/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import DynamicImageLoader from "../dynamicImageLoader";
import { useUserContext } from "../../contexts/userContext";

/* Components */

/* Styles */
import styles from "./styles.js"


const MileageHeader = ({ descriptionId }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  return (
    <div className={classes.mileageWrapper}>
      <div className={classes.logo}>
        <DynamicImageLoader imageName={"plane-icon.svg"} />
      </div>
      <h1><FormattedMessage id="reportsNoMileage.title"/></h1>
      <p><FormattedMessage id={descriptionId || `reportsNoMileage.description.${providerCode}`}/></p>
    </div>
  )
}

export default MileageHeader;
